import { render } from "./PriceModel.vue?vue&type=template&id=eb42c652&scoped=true"
import script from "./PriceModel.vue?vue&type=script&lang=js"
export * from "./PriceModel.vue?vue&type=script&lang=js"

import "./PriceModel.vue?vue&type=style&index=0&id=eb42c652&scoped=true&lang=css"

import exportComponent from "/var/www/html/smartbooking/smartbooking-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb42c652"]])

export default __exports__